import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryQuestionContent extends ConditionRegistryCategory {
    label = 'Inhalt';
    constructor(parent) {
        super(parent);
        super.init();
    }
    questionTextHasUnderscore = () => new ConditionRegistryItem({
        eval: ({ question }) => {
            if (!question)
                return false;
            return question.textBasis.includes('_');
        },
    });
}
